module.exports = __webpack_public_path__ + "img/2@s.ce87c1fe.jpg";